import { render, staticRenderFns } from "./dynamic-tabbed-nav-minimal.vue?vue&type=template&id=6dca8426&"
import script from "./dynamic-tabbed-nav-minimal.vue?vue&type=script&lang=js&"
export * from "./dynamic-tabbed-nav-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports